import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import moment from 'moment';
export function LessOrEqualThanDate(controlName: string, matchingControlName: string): ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    const formGroup = control as FormGroup;
    const from = formGroup.controls[controlName];
    const to = formGroup.controls[matchingControlName];

    if (!from || !to || !from.value || !to.value) return null;
    if (from.value > to.value) {
      return { lessThan: true };
    }
    return null;
  };
}
